import React from 'react';
import { PageHeader } from '../../../../shared/components/patterns';

const CompletedHeader = () => {
  return (
    <PageHeader
      title="Affari completati"
      description="Storico cessioni crediti completate per fase di lavorazione"
    />
  );
};

export default CompletedHeader;
